// extracted by mini-css-extract-plugin
export default {"root":"dashboard-layout_root__5vROY","right":"dashboard-layout_right__O0Wm3","page":"dashboard-layout_page__J5-Rd","content":"dashboard-layout_content__kI+qj"};